<div *ngIf="vibrationRecords != undefined" class="scrollable-container text-size">
    <div class="d-flex align-items-center gap-2 px-2 pt-2 select-class">
        <input type="checkbox" [checked]="allSelected" (change)="toggleSelectAll()" />
        {{ 'RECORDS.SELECT_UNSELECT_ALL' | translate }}
        <div class="ms-auto">
            <button
                *ngIf="selectedRecordIds.size > 0"
                type="button"
                class="tertiary-button delete-multiple-button"
                (click)="deleteSelected()">
                <img src="icon/delete.svg" class="me-1" />
                {{ 'BUTTONS.DELETE' | translate }} ({{selectedRecordIds.size}})
            </button>
        </div>
        <div class="p-2 pl-0">
            <button type="button" class="tertiary-button"
                (click)="openReportModal()">
                <img src="icon/report.svg" class="me-2" /> {{'REPORT.REPORT' | translate}}
            </button>
        </div>
    </div>
    <!-- Table header -->
    <div class="row fw-semibold text-muted border-bottom py-1 px-2 mt-2" style="font-size: 0.78rem;">
        <div class="col-auto" style="min-width: 2rem;"></div>
        <div class="col-8">
            <div class="row">
                <div class="col-3">
                    <div class="channel-preview-header mb-0">
                        <ng-container [ngSwitch]="selectedPreviewChannel">
                            <span *ngSwitchCase="1">{{ 'VIBRATION.VERTICAL' | translate }}</span>
                            <span *ngSwitchCase="2">{{ 'VIBRATION.LONGITUDE' | translate }}</span>
                            <span *ngSwitchCase="3">{{ 'VIBRATION.TRANSVERSE' | translate }}</span>
                            <span *ngSwitchDefault>{{ 'RECORD.CHANNEL' | translate }} {{ selectedPreviewChannel }}</span>
                        </ng-container>
                        <button
                            type="button"
                            class="channel-nav-button"
                            (click)="showPreviousPreviewChannel()">
                            <img src="./icon/arrow-left.svg" alt="Previous channel" />
                        </button>
                        <button
                            type="button"
                            class="channel-nav-button"
                            (click)="showNextPreviewChannel()">
                            <img src="./icon/arrow-right.svg" alt="Next channel" />
                        </button>
                    </div>
                </div>
                <div class="col-3">{{ 'RECORD.TIMESTAMP' | translate }}</div>
                <div class="col-3">{{ 'RECORD.VIBRATIONS' | translate }} (mm/s)</div>
                <div class="col-3">{{ 'RECORD.NOTES' | translate }}</div>
            </div>
        </div>
        <div class="col">{{ 'RECORD.ASSIGNMENT' | translate }}</div>
    </div>
    <div *ngFor="let record of vibrationRecords; index as j;" class="text-start"
    [attr.id]="'record-row-' + record.id"
    [ngClass]="{ detailledborder: isDetailsVisible[j], 'record-auto-highlight': highlightedRecordId === record.id }">
        <hr *ngIf="j > 0" class="my-1 mt-0" />
        <div class="row">
            <div class="pt-4 col-auto pe-2">
                <input type="checkbox" [checked]="selectedRecordIds.has(record.id)" (change)="toggleSelection(record.id)" />
            </div>
            <div class="col-8">
                <div class="row">
                    <div class="col-12">
                        <div class="row text-start">
                            <div class="col-3 pt-3" >
                                <div *ngIf="!hasPreviewChannels(record)" class="text-muted" style="font-size: 0.75rem; font-style: italic;">
                                    {{ 'RECORD.NO_PREVIEW_AVAILABLE' | translate }}
                                </div>
                                <img
                                    *ngIf="hasPreviewChannels(record) && getSelectedPreviewImageSrc(record) as previewSrc"
                                    [src]="previewSrc"
                                    alt="Channel preview"
                                    class="channel-preview"
                                />
                                <div class="preview-metadata mt-1 d-flex flex-wrap gap-1">
                                    <span class="preview-chip">{{ 'REPORT.TYPE' | translate }}: {{ record?.recordMetadata?.recordType || '--' }}</span>
                                    <span class="preview-chip">{{ 'RECORD.RECORD_LENGTH' | translate }}: {{ formatRecordLength(record) }}</span>
                                </div>
                            </div>
                            <div class="col-3">
                                <div class="d-flex align-items-start gap-2">
                                    
                                    <div>
                                        <div>Date: {{record?.recordMetadata.timestamp | date: 'dd/MM/yyyy'}}</div>
                                        <div>Time: {{record?.recordMetadata.timestamp | date: 'HH:mm:ss'}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-3">
                                <div>
                                    <span>
                                        V:
                                        <ng-container *ngIf="!isNaN(record?.recordMetadata?.verticalPpv)">
                                            {{record?.recordMetadata.verticalPpv | number : '1.2-2'}}
                                          </ng-container>
                                          <ng-container *ngIf="isNaN(record?.recordMetadata?.verticalPpv)">
                                            N/A
                                          </ng-container>
                                    </span>
                                    <span class="ms-2">
                                        L:
                                        <ng-container *ngIf="!isNaN(record?.recordMetadata?.longitudinalPpv)">
                                          {{record?.recordMetadata.longitudinalPpv | number : '1.2-2'}}
                                        </ng-container>
                                        <ng-container *ngIf="isNaN(record?.recordMetadata?.longitudinalPpv)">
                                          N/A
                                        </ng-container>
                                      </span>
                                </div>
                                <div>
                                    <span>
                                        T:
                                        <ng-container *ngIf="!isNaN(record?.recordMetadata?.transversePpv)">
                                            {{record?.recordMetadata.transversePpv | number : '1.2-2'}}
                                          </ng-container>
                                          <ng-container *ngIf="isNaN(record?.recordMetadata?.transversePpv)">
                                            N/A
                                          </ng-container>
                                    </span>
                                    <span class="ms-2">
                                        VS: 
                                        <ng-container *ngIf="!isNaN(record?.recordMetadata?.vecSomme)">
                                            {{record?.recordMetadata.vecSomme | number : '1.2-2'}}
                                          </ng-container>
                                          <ng-container *ngIf="isNaN(record?.recordMetadata?.vecSomme)">
                                            N/A
                                          </ng-container>
                                    </span>
                                </div>
                                <div *ngIf="shouldShowPreviewFrequency(record)">
                                    <span>
                                        {{ 'REPORT.FREQUENCY' | translate }}:
                                        {{ formatMaxFrequency(record) }}
                                    </span>
                                </div>
                            </div>
                            
                            <div class="col-3 notes-cell">
                                <div class="d-flex align-items-start justify-content-between w-100">
                                    <div class="pe-2 notes-text-list">
                                        <div class="note-text" *ngIf="record?.recordMetadata.note1?.trim()">{{record?.recordMetadata.note1}}</div>
                                        <div class="note-text" *ngIf="record?.recordMetadata.note2?.trim()">{{record?.recordMetadata.note2}}</div>
                                        <div class="note-text" *ngIf="record?.recordMetadata.note3?.trim()">{{record?.recordMetadata.note3}}</div>
                                    </div>
                                    <div class="cursor flex-shrink-0" (click)="onNotesEdit(j)">
                                        <img src="./icon/edit-pencil.svg" />
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div class="row text-start mt-3" *ngIf="isDetailsVisible[j]">
                            <div class="col-3">
                                <div class="text-muted">PPV max(mm/s)</div>
                                <div>{{ getPicPPVFirstThree(record) | number : '1.2-2' }}
                                    ( {{ getMaxFrequencyFirstThree(record) }}
                                    <span>Hz</span> )
                                </div>
                                
                            </div>
                            <div class="col-3">
                                <div class="cursor" (click)="onDistanceEdit(record, j)"> <span class="text-muted"> {{
                                        'RECORD.DISTANCE' | translate }} </span>
                                    <img src="./icon/edit-pencil.svg" />
                                </div>
                                <div>{{record?.distance}} m</div>
                            </div>
                            <div class="col-3">
                                <div class="text-muted"> {{'RECORD.AIR_OVERPRESSURE' | translate}}</div>
                                <div *ngIf="record?.recordMetadata?.numberOfChannels > 3">
                                    Pa: 
                                    <ng-container *ngIf="!isNaN(record?.recordMetadata?.overpressure)">
                                        {{record?.recordMetadata.overpressure | number : '1.2-2'}}
                                      </ng-container>
                                      <ng-container *ngIf="isNaN(record?.recordMetadata?.overpressure)">
                                        N/A
                                      </ng-container>
                                </div>
                                <div *ngIf="record?.recordMetadata?.numberOfChannels > 3">
                                    dB(L): 
                                    <ng-container *ngIf="!isNaN(record?.recordMetadata?.overpressure)">
                                        {{
                                    pascalToDecibel(record?.recordMetadata.overpressure) | number : '1.2-2' }}
                                      </ng-container>
                                      <ng-container *ngIf="isNaN(record?.recordMetadata?.overpressure)">
                                        N/A
                                      </ng-container>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>
            <div class="col border-left-line ps-3">
                <div class="d-flex align-items-start w-100">
                    <div class="assignment-content flex-grow-1">
                        <div class="pe-2">
                            <div *ngIf="record?.eventId"><img src="./icon/blastMenu.svg" /> <span class="ms-1">
                                    {{eventData? eventData.name : getEvent(record.eventId)?.name}}
                                </span>
                            </div>

                            <div *ngIf="!record?.eventId" class="opacity-50 text-muted">
                                <div class="d-flex align-items-center gap-2 assignment-inline-row">
                                    <img src="./icon/question-mark.svg" />
                                    <span>{{'EVENT.LABEL' | translate}} {{'RECORD.UNASSIGNED' | translate}}</span>
                                </div>
                            </div>

                            <div *ngIf="record?.controlPointId"><img src="./icon/control-point-black.svg" /> <span
                                    class="ms-1">
                                    {{record?.controlPointName}}
                                </span>
                            </div>
                            <div *ngIf="!record?.controlPointId" class="opacity-50 text-muted">
                                <div class="d-flex align-items-center gap-2 assignment-inline-row">
                                    <img src="./icon/question-mark.svg" />
                                    <span>{{'NAVIGATION.MEASUREMENT_POINT' | translate}} {{'RECORD.UNASSIGNED' | translate}}</span>
                                </div>
                            </div>

                            <div><img src="./icon/device.svg" /><span class="ms-1">
                                    {{record?.recordMetadata.seismographName ??
                                    record?.recordMetadata.seismographSerialNumber}}

                                </span>
                            </div>
                        </div>
                    </div>
                    <div (click)="toggleDetails(j)" class="d-flex justify-content-end align-items-end cursor ms-auto flex-shrink-0 assignment-chevron">
                        <img [src]="isDetailsVisible[j] ? './icon/arraw-up.svg' : './icon/arraw-down.svg'" />
                    </div>
                </div>
                <div class="row" *ngIf="isDetailsVisible[j]">
                    <div class="d-flex justify-content-start align-items-center gap-2 mt-3">
                        <button 
                            type="button" 
                            class="secondary-button"
                            (click)="openFile(record)"
                            [disabled]="isDownloading"
                            title="{{ 'BUTTONS.DOWNLOAD' | translate }}">
                            <img class="img" src="icon/download.svg" />
                        </button>
                    </div>
                </div>
            </div>

            <div *ngIf="isDetailsVisible[j]">
                <hr class="">
                <div class="row text-size" *ngIf="record != undefined">
                     <div class="col-9" style="position: relative;">
                        <div>
                            <div *ngIf="selectedTab === 'main'">
                                <app-vibration-chart-horizontal [siteId]="siteId" [eventId]="eventData?.id"
                                    [vibrationRecord]="record" [ponderations]="ponderations" [selectedPonderationId]="selectedPonderationId"></app-vibration-chart-horizontal>
                            </div>
                            <div *ngIf="selectedTab === 'fft' && record?.recordMetadata?.recordType != 'Bargraph'">
                                <span></span>
                            </div>
                            <div *ngIf="selectedTab === 'standard'">
                                <span></span>
                            </div>
                            <div class="record-detail">

                                <div class="p-2">
                                    <button type="button" class="primary-button"
                                         (click)="downloadReport(record)">
                                        <img src="icon/result.svg" /> {{'REPORT.REPORT' | translate}}
                                    </button>
                                </div>
                                <div class="p-2 pl-0">
                                    <button type="button" class="tertiary-button"
                                        (click)="deleteRecord(record.id.toString())">
                                        <img src="icon/delete.svg" /> {{'BUTTONS.DELETE_RECORD' | translate}}
                                    </button>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="col-3 border-left-line">
                        <app-records-assignment [isEventAssigned]="record.eventId !== null && record.eventId !== 0"
                            [isControlPointAssigned]="record.controlPointId != 0 && record.controlPointId != null"
                            [eventdata]="eventData? eventData : getEvent(record.eventId)" [vibrationRecord]="record"
                            [siteId]="siteId" [controlPoints]="controlPoints"
                            [deviceRef]="record?.recordMetadata.seismographSerialNumber"></app-records-assignment>
                    </div>

                </div>
            </div>
        </div>
    </div>